// extracted by mini-css-extract-plugin
module.exports = {"main":"lor5x"};